<template>
  <div>
    <div
      @mouseenter="showTooltip = true"
      @mouseleave="showTooltip = false"
      @mousemove="updatePosition"
    >
      <slot />
    </div>
    <transition>
      <div v-if="showTooltip" class="tooltip">
        {{ tooltipText }}
        <span class="tooltip-arrow"></span>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  props: {
    text: { type: String },
    isPopUp: { type: Boolean },
  },
  setup(props) {
    const showTooltip = ref(false);
    const tooltipText = ref(props.text);
    const x = ref(0);
    const y = ref(props.y);

    const updatePosition = (event) => {
      const tooltipEl = document.querySelector('.tooltip');
      if (tooltipEl) {
        const width = tooltipEl.offsetWidth;

        let left = event.clientX + x.value;

        if (left + width > window.innerWidth) {
          left = event.clientX - width;
        } else if (left < 0) {
          left = 0;
        }
        if (props.isPopUp) {
          x.value = left;
        } else {
          x.value = left - 236;
        }
      }
    };

    onMounted(() => {
      const tooltipEl = document.querySelector('.tooltip');
      if (tooltipEl) {
        const width = tooltipEl.offsetWidth;
        x.value = -width / 2;
      }
    });

    return {
      showTooltip,
      tooltipText,
      x,
      y,
      updatePosition,
    };
  },
};
</script>

<style lang="sass">
.tooltip
  position: absolute
  background-color: #FFFFFF
  color: #1C1C1E
  border: 1px #F0F3F5 solid
  padding: 0.5rem 1rem
  border-radius: 0.25rem
  font-size: 12px
  top: 45px
  &::after
    content: ""
    position: absolute
    bottom: 100%
    left: 50%
    margin-left: -10px
    border-width: 5px
    border-style: solid
    border-color: transparent transparent #F0F3F5 transparent
</style>
